const LOCALE_LANGUAGE_MAP: Record<string, string> = {
  "/de-de/": "de",
  "/fr-fr/": "fr",
  "/es-es/": "es",
  "/es-la/": "es",
  "/ja-jp/": "ja",
  "/pt-br/": "pt",
};

// DRLP pages have no CMS locale field: a translated variant is a separate
// document distinguished only by a slug suffix (e.g. /drlp/ai-agent-fr).
const DRLP_SLUG_LANGUAGE_SUFFIXES: Record<string, string> = {
  "-br": "pt",
  "-fr": "fr",
  "-de": "de",
  "-jp": "ja",
  "-es": "es",
  "-it": "it",
};

const DRLP_SLUG_RE = /^\/drlp(?:-v2)?\/(?:preview\/)?([^/]+)$/;

export function getLanguageOverride(pathname: string): string | undefined {
  for (const [prefix, lang] of Object.entries(LOCALE_LANGUAGE_MAP)) {
    if (pathname.startsWith(prefix) || pathname === prefix.slice(0, -1)) {
      return lang;
    }
  }

  const slug = pathname.match(DRLP_SLUG_RE)?.[1];
  if (slug) {
    for (const [suffix, lang] of Object.entries(DRLP_SLUG_LANGUAGE_SUFFIXES)) {
      if (slug.endsWith(suffix)) return lang;
    }
  }

  return undefined;
}

// Pins "en" where getLanguageOverride returns undefined: the demo Messenger resumes its last stored language, so omitting the override leaves a visitor arriving from a locale page on that page's language.
export function getDemoLanguageOverride(pathname: string): string {
  return getLanguageOverride(pathname) ?? "en";
}
